import React from "react";
import MessageContainer from "components/chat/MessageContainer";
import { Stack } from "@mui/material";
import DownloadImageButton from "components/chat/DownloadImageButton";
import DownloadableImage from "./DownloadableImage";

export default function ImageMessage({ message, renderContainer = true, canDelete = true, canUseAsPrompt = true }) {
  const renderBottomContent = () => {
    return <DownloadImageButton imageUrl={message.image} />;
  };

  const renderContent = () => {
    return (
      <Stack alignItems="center" justfiycontent="center">
        {/* <img src={message.image} alt="" width="40%" /> */}
        <DownloadableImage imageSrc={message.image} />
      </Stack>
    );
  };

  if(!renderContainer) return renderContent();

  return (
    <MessageContainer
      message={message}
      bottomContent={renderBottomContent()}
      canDelete={canDelete}
      canUseAsPrompt={canUseAsPrompt}
    >
      {renderContent()}
    </MessageContainer>
  );
}
